import { cx } from "@jugl-web/utils";
import { ReactNode, forwardRef, useMemo } from "react";
import {
  InteractiveContainer,
  InteractiveContainerProps,
} from "../../../primitives/InteractiveContainer";

export interface TableDropdownCellProps {
  children: ReactNode;
  classNames?: {
    cell?: string;
    text?: string;
  };
  backgroundColor?: string;
  textColor?: string;
  isDisabled?: boolean;
  onClick?: InteractiveContainerProps["onClick"];
}

export const TableDropdownCell = forwardRef<
  HTMLDivElement,
  TableDropdownCellProps
>(
  (
    { children, classNames, backgroundColor, textColor, isDisabled, onClick },
    ref
  ) => {
    const isInteractive = !!onClick;

    const { cellStyle, textStyle } = useMemo(() => {
      return {
        cellStyle: backgroundColor ? { backgroundColor } : undefined,
        textStyle: textColor ? { color: textColor } : undefined,
      };
    }, [backgroundColor, textColor]);

    return (
      <InteractiveContainer
        ref={ref}
        className={cx(
          "flex h-full w-full items-center justify-center border border-solid border-white p-4",
          classNames?.cell
        )}
        style={cellStyle}
        isDisabled={isDisabled || !isInteractive}
        onClick={onClick}
      >
        <span
          className={cx("truncate font-secondary text-sm", classNames?.text)}
          style={textStyle}
        >
          {children}
        </span>
      </InteractiveContainer>
    );
  }
);
